/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import ProductTypesForm from '../components/form';
import { ADD_PRODUCT_TYPE } from '../../../../queries/products/productType';

export const AddProductTypes = (props) => {
  return (
    <Mutation
      mutation={ADD_PRODUCT_TYPE}
      update={async () => {
        await props.refetch();
      }}
    >

      {createTitle => (
        <ProductTypesForm query_f={createTitle} {...props} />
      )}
    </Mutation>
  );
};
